module.exports = __webpack_public_path__ + "img/navbar.6a94aa21.png";